import {
  type HttpEvent,
  type HttpHandler,
  type HttpInterceptor,
  type HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { projectCurrentDeviceContextHeaders } from '@automatick/shared-ts';
import type { Observable } from 'rxjs';
import { CurrentDeviceContextService } from './current-device-context.service';

@Injectable()
export class CurrentDeviceContextInterceptor implements HttpInterceptor {
  private readonly currentDeviceContext = inject(CurrentDeviceContextService);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const context = this.currentDeviceContext.snapshot();
    let headers = request.headers;
    for (const [name, value] of projectCurrentDeviceContextHeaders(context)) {
      headers = headers.set(name, value);
    }

    return next.handle(request.clone({ headers }));
  }
}
